<template lang="pug">
  .sales
    .sales-info 
      .sales__graph 
        highcharts(:options="changeGraph()")
      .sales__legend.legend-sales
        .legend-sales__title Канал
        .legend-sales__content
          a(href='#' 
            v-for='channel in channels'
            :class="[{checked: channel.checked}, 'legend-sales__link--'+ channel.color]" 
            @click.prevent="channelGraph(channel.index)"
            ).legend-sales__link
            span 
              svgicon(name='check')
            | {{ channel.title }}

    .channel-sales
      h2.h2 Каналы продаж
      .channel-sales__table-wrap
        .channel-sales__table
          .channel-sales__title
            .cs-col1 Канал
            .cs-col2 Сумма
            .cs-col3 Оплачено заказов
          .channel-sales__content
            .channel-sales__tr-first
              .cs-col1.item-channel__title Итого
              .cs-col2.item-channel__summ 1 108 375 Р 
                span.item-channel__dynamic.item-channel__dynamic--up +7%
              .cs-col3.item-channel__paid 630 
                span.item-channel__dynamic.item-channel__dynamic--down -5%
            a(href='#' 
              :class="[{checked: channels[0].checked}]" 
              @click.prevent="channelGraph(0)"
              ).channel-sales__item.item-channel
              .cs-col1.item-channel__title 
                span 
                  svgicon(name='check')
                | Кассиры
              .cs-col2.item-channel__summ 468 500 Р
              .cs-col3.item-channel__paid 252
            a(href='#' 
              :class="[{checked: channels[1].checked}]" 
              @click.prevent="channelGraph(1)"
              ).channel-sales__item.item-channel
              .cs-col1.item-channel__title 
                span 
                  svgicon(name='check')
                | Яндекс.Директ
              .cs-col2.item-channel__summ 123 000 Р
              .cs-col3.item-channel__paid 145
            a(href='#' 
              :class="[{checked: channels[2].checked}]" 
              @click.prevent="channelGraph(2)"
              ).channel-sales__item.item-channel
              .cs-col1.item-channel__title 
                span 
                  svgicon(name='check')
                | Вконтакте
              .cs-col2.item-channel__summ 98 000 Р
              .cs-col3.item-channel__paid 97
            a(href='#' 
              :class="[{checked: channels[3].checked}]" 
              @click.prevent="channelGraph(3)"
              ).channel-sales__item.item-channel
              .cs-col1.item-channel__title 
                span 
                  svgicon(name='check')
                |  Google Adwords
              .cs-col2.item-channel__summ 73 000 Р
              .cs-col3.item-channel__paid 65
            a(href='#' 
              :class="[{checked: channels[4].checked}]" 
              @click.prevent="channelGraph(4)"
              ).channel-sales__item.item-channel
              .cs-col1.item-channel__title 
                span 
                  svgicon(name='check')
                |  Прочие
              .cs-col2.item-channel__summ 55 000 Р
              .cs-col3.item-channel__paid 21
</template>

<script>
export default {
  props: ['activeLink', 'selectedTime'],
  data() {
    return {
      channels: [
        {
          index: 0,
          name: 'cashiers',
          title: 'Кассиры',
          color: 'fiolet',
          checked: false,
        },
        {
          index: 1,
          name: 'yd',
          title: 'Яндекс.Директ',
          color: 'green',
          checked: true,
        },
        {
          index: 2,
          name: 'vk',
          title: 'Вконтакте',
          color: 'blue',
          checked: true,
        },
        {
          index: 3,
          name: 'ga',
          title: 'Google Adwords',
          color: 'yellow',
          checked: true,
        },
        { 
          index: 4,
          name: 'other',
          title: 'Прочие',
          color: 'orange',
          checked: true,
        }
      ],
      SalesDay: {
        chart: {
          events: {
            load: (function(self) {
              return function() {
                self.chart = this;
              };
            })(this)
          },
          type: 'line',
          height: 355,
        },
        credits: false,
        title: false,
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%e.%m.%y'
          },
          gridLineWidth: 1,
          labels:{
            align: 'left',
            style: {
              color: '#9398a2',
            }
          },
          minRange: 3,
        },
        yAxis: {
          title: false,
          showFirstLabel: false,
          labels:{
            align: 'left',
            distance: 0,
            y: 12,
            x: 10,
            format: '{value} Р',
            style: {
              color: '#9398a2',
            },
          }
        },
        legend: false,
        plotOptions: {
          line: {
            marker: false,
            lineWidth: 2,
          }
        },
        tooltip: {
          backgroundColor: '#fff',
          borderColor: 'transparent',
          borderRadius: 0,
          borderWidth: 0,
          padding: 10,
          xDateFormat: '%d.%m.%y %A',
          useHTML: true,
          headerFormat: '{point.key}<br>',
          pointFormat: '<b>Доход {point.y} Р</b>',
          valueDecimals: 0
        },
        series: [{
          name: 'Кассиры',
          data: [
            [1513036800000, 12000], 
            [1513123200000, 3000], 
            [1513209600000, 4000], 
            [1513296000000, 8000], 
            [1513555200000, 3000], 
            [1513641600000, 10000], 
            [1513728000000, 20000], 
            [1513814400000, 16000], 
            [1513900800000, 8000], 
            [1514332800000, 2000], 
            [1514419200000, 3000], 
            [1514505600000, 4000]
          ],
          color: '#b751bb',
          visible: false,
        }, {
          name: 'Яндекс.Директ',
          data: [
            [1513036800000, 25000], 
            [1513123200000, 21000], 
            [1513209600000, 18000], 
            [1513296000000, 30000], 
            [1513555200000, 10000], 
            [1513641600000, 15000], 
            [1513728000000, 19000], 
            [1513814400000, 25000], 
            [1513900800000, 17000], 
            [1514332800000, 19000], 
            [1514419200000, 22000], 
            [1514505600000, 12000]
          ],
          color: '#78c076',
          visible: true,
        }, {
          name: 'Вконтакте',
          data: [
            [1513036800000, 22000], 
            [1513123200000, 30000], 
            [1513209600000, 24000], 
            [1513296000000, 18000], 
            [1513555200000, 23000], 
            [1513641600000, 30000], 
            [1513728000000, 20000], 
            [1513814400000, 6000], 
            [1513900800000, 18000], 
            [1514332800000, 22000], 
            [1514419200000, 31000], 
            [1514505600000, 24000]
          ],
          color: '#008cff',
          visible: true,
        },{
          name: 'Google Adwords',
          data: [
            [1513036800000, 5000], 
            [1513123200000, 7000], 
            [1513209600000, 8000], 
            [1513296000000, 10000], 
            [1513555200000, 12000], 
            [1513641600000, 11000], 
            [1513728000000, 6000], 
            [1513814400000, 15000], 
            [1513900800000, 17000], 
            [1514332800000, 12000], 
            [1514419200000, 21000], 
            [1514505600000, 9000]
          ],
          color: '#ffcc00',
          visible: true,
        }, {
          name: 'Прочие',
          data: [
            [1513036800000, 35000], 
            [1513123200000, 33000], 
            [1513209600000, 30000], 
            [1513296000000, 32000], 
            [1513555200000, 20000], 
            [1513641600000, 35000], 
            [1513728000000, 19000], 
            [1513814400000, 35000], 
            [1513900800000, 30000], 
            [1514332800000, 19000], 
            [1514419200000, 32000], 
            [1514505600000, 22000]
          ],
          color: '#ff6633',
          visible: true,
        }]
      },
      SalesWeek: {
        chart: {
          events: {
            load: (function(self) {
              return function() {
                self.chart = this;
              };
            })(this)
          },
          type: 'line',
          height: 355,
        },
        credits: false,
        title: false,
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%e.%m.%y'
          },
          gridLineWidth: 1,
          labels:{
            align: 'left',
            style: {
              color: '#9398a2',
            }
          },
          minRange: 3,
        },
        yAxis: {
          title: false,
          showFirstLabel: false,
          labels:{
            align: 'left',
            distance: 0,
            y: 12,
            x: 10,
            format: '{value} Р',
            style: {
              color: '#9398a2',
            },
          }
        },
        legend: false,
        plotOptions: {
          line: {
            marker: false,
            lineWidth: 2,
          }
        },
        tooltip: {
          backgroundColor: '#fff',
          borderColor: 'transparent',
          borderRadius: 0,
          borderWidth: 0,
          padding: 10,
          xDateFormat: '%d.%m.%y %A',
          useHTML: true,
          headerFormat: '{point.key}<br>',
          pointFormat: '<b>Доход {point.y} Р</b>',
          valueDecimals: 0
        },
        series: [{
          name: 'Кассиры',
          data: [
            [1513036800000, 29000], 
            [1513641600000, 46000],  
            [1514419200000, 7000], 
          ],
          color: '#b751bb',
          visible: false,
        }, {
          name: 'Яндекс.Директ',
          data: [
            [1513036800000, 104000], 
            [1513900800000, 76000], 
            [1514505600000, 53000]
          ],
          color: '#78c076',
          visible: true,
        }, {
          name: 'Вконтакте',
          data: [ 
            [1513036800000, 117000], 
            [1513900800000, 74000], 
            [1514505600000, 77000]
          ],
          color: '#008cff',
          visible: true,
        },{
          name: 'Google Adwords',
          data: [
            [1513036800000, 42000], 
            [1513900800000, 49000], 
            [1514505600000, 42000]
          ],
          color: '#ffcc00',
          visible: true,
        }, {
          name: 'Прочие',
          data: [
            [1513036800000, 150000], 
            [1513900800000, 119000], 
            [1514505600000, 73000]
          ],
          color: '#ff6633',
          visible: true,
        }]
      },
      SalesMonth: {
        chart: {
          events: {
            load: (function(self) {
              return function() {
                self.chart = this;
              };
            })(this)
          },
          type: 'line',
          height: 355,
        },
        credits: false,
        title: false,
        xAxis: {
          type: 'datetime',
          dateTimeLabelFormats: {
            day: '%e.%m.%y'
          },
          gridLineWidth: 1,
          labels:{
            align: 'left',
            style: {
              color: '#9398a2',
            }
          },
          minRange: 3,
        },
        yAxis: {
          title: false,
          showFirstLabel: false,
          labels:{
            align: 'left',
            distance: 0,
            y: 12,
            x: 10,
            format: '{value} Р',
            style: {
              color: '#9398a2',
            },
          }
        },
        legend: false,
        plotOptions: {
          line: {
            marker: false,
            lineWidth: 2,
          }
        },
        tooltip: {
          backgroundColor: '#fff',
          borderColor: 'transparent',
          borderRadius: 0,
          borderWidth: 0,
          padding: 10,
          xDateFormat: '%d.%m.%y %A',
          useHTML: true,
          headerFormat: '{point.key}<br>',
          pointFormat: '<b>Доход {point.y} Р</b>',
          valueDecimals: 0
        },
        series: [{
          name: 'Кассиры',
          data: [
            [1513036800000, 55000], 
            [1514419200000, 82000], 
          ],
          color: '#b751bb',
          visible: false,
        }, {
          name: 'Яндекс.Директ',
          data: [
            [1513036800000, 200000], 
            [1514505600000, 233000]
          ],
          color: '#78c076',
          visible: true,
        }, {
          name: 'Вконтакте',
          data: [ 
            [1513036800000, 125000], 
            [1514505600000, 268000]
          ],
          color: '#008cff',
          visible: true,
        },{
          name: 'Google Adwords',
          data: [
            [1513036800000, 125000], 
            [1514505600000, 133000]
          ],
          color: '#ffcc00',
          visible: true,
        }, {
          name: 'Прочие',
          data: [ 
            [1513036800000, 225000], 
            [1514505600000, 302000]
          ],
          color: '#ff6633',
          visible: true,
        }]
      },
    }
  },
  methods: {
    channelGraph(count) {
      this.channels[count].checked = !this.channels[count].checked;
      this.SalesDay.series[count].visible = !this.SalesDay.series[count].visible;
      this.SalesWeek.series[count].visible = !this.SalesWeek.series[count].visible;
      this.SalesMonth.series[count].visible = !this.SalesMonth.series[count].visible;
    },
    graphTime(time) {
      const day = 3600*24*1000;
      const chart = this.chart.xAxis[0];
      const dateMax = chart.getExtremes().dataMax;
      const dateMin = chart.getExtremes().dataMin;
      const period = time || this.activeLink;
      let start;
      let end = dateMax;
      switch (period) {
        case 'yesterday':
        start = dateMax - day;
        end = start + day;
        break;
        case 'today':
        start = dateMax;
        end = dateMax;
        break;
        case 'week':
        start = dateMax - (day * 7);
        break;
        case 'month':
        start = dateMax - (day * 30);
        break;
        case 'quarter':
        start = dateMax - (day * 90);
        break;
        case 'halfyear':
        start = dateMax - (day * 180);
        break;
        case 'onstart':
        start = dateMin;
        break;
        default:
        start = dateMin;
      }

      this.viewDate(start, end);
      chart.setExtremes(start, end);
    },
    viewDate(from, to){
      const startFormatted = new Date(from);
      const start = {
        year: startFormatted.getFullYear(),
        month: ('0' + (startFormatted.getMonth()+1)).slice(-2),
        day: ('0' + (startFormatted.getDate())).slice(-2)
      };
      const endFormatted = new Date(to);
      const end = {
        year: endFormatted.getFullYear(),
        month: ('0' + (endFormatted.getMonth()+1)).slice(-2),
        day: ('0' + (endFormatted.getDate())).slice(-2)
      };
      let result;
      if(start.year == end.year) {
        if(start.month == end.month) {
          if(start.day == end.day) {
            result = `${end.day} ${month(end.month)} ${end.year}`;
          } else {
            result = `${start.day} — ${end.day} ${month(end.month)} ${end.year}`;
          }          
        } else {
          result = `${start.day} ${month(start.month)} — ${end.day} ${month(end.month)} ${end.year}`;
        }
      } else {
        result = `${start.day} ${month(start.month)} ${start.year} — ${end.day} ${month(end.month)} ${end.year}`;
      }
      function month(value) {
        const months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
        return months[parseInt(value) - 1];
      }
      this.$emit('period', result)   
      return result;
    },
    changeGraph(){
      let result;
      switch (this.selectedTime) {
        case 'По дням':
          result = this.SalesDay;
          break;
        case 'По неделям':
          result = this.SalesWeek;
          break;
        case 'По месяцам':
          result = this.SalesMonth;
          break;
        default: result = this.SalesDay;
          break;
      }
      return result;
    }
  },
  mounted: function() {
    this.$parent.$on('extremes', this.graphTime);
    this.graphTime(this.activeLink);
  },
  computed: {
  }
}
</script>

<style lang="scss">
.sales{
  &-info{
    display: flex;
    margin-bottom: 40px;
  }
  &__graph{
    width: 830px;
    margin-right: 20px;
  }
}
.legend-sales{
  &__title{
    color: #9398a2;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 15px;
  }
  &__content{
    display: flex;
    flex-direction: column;
  }
  &__link{
    color: #161616;
    font-size: 14px;
    margin-bottom: 20px;
    display: inline-flex;
    align-items: center;
    text-decoration: none;
    position: relative;
    span{
      border: 1px solid #e4e4e4;
      background-color: #fff;
      width: 18px;
      height: 18px;
      margin-right: 35px;
      border-radius: 50%;
      color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      .svg-icon{
        width: 12px;
        height: 9px;
        display: block;
      }
    }
    &:before{
      content: '';
      width: 12px;
      height: 12px;
      border-radius: 50%;
      background: #ccc;
      position: absolute;
      left: 32px;
      top: auto;
      bottom: auto;
    }
    &--fiolet:before{
      background: #b751bb;
    }
    &--green:before{
      background: #78c076;
    }
    &--blue:before{
      background: #266dff;
    }
    &--yellow:before{
      background: #ffcc00;
    }
    &--orange:before{
      background: #ff6633;
    }
    &:hover{
      color: #008cff;
    }
    &.checked{
      span{
        background: #008cff;
        border-color: #008cff;
        color: #fff;
      }
    }
  }
}
.channel-sales{
  &__title{
    display: flex;
    color: #9398a2;
    font-size: 14px;
    margin-bottom: 15px;
    padding: 0px 25px;
  }
  &__content{
    box-shadow: 0 0 10px rgba(196, 202, 214, 0.8);
    background-color: #ffffff;
    border: 1px solid #e4e4e4;
  }
  &__tr-first{
    display: flex;
    background-color: #f4f5f6;
    padding: 20px 25px;
    color: #161616;
    font-size: 16px;
    font-weight: 700;
  }
}
.item-channel{
  display: flex;
  text-decoration: none;
  color: #161616;
  font-size: 16px;
  font-weight: 700;
  padding: 18px 25px;
  border-top: 1px solid #e4e4e4;
  &:hover{
    background-color: #e7f1f8;
  }
  &.checked{
    .item-channel__title span{
      background: #008cff;
      border-color: #008cff;
      color: #fff;
    }
  }
  &__title{
    color: #161616;
    font-size: 16px;
    font-weight: 600;
    display: flex;
    span{
      border: 1px solid #e4e4e4;
      background-color: #fff;
      width: 18px;
      height: 18px;
      margin-right: 18px;
      border-radius: 50%;
      color: transparent;
      display: flex;
      justify-content: center;
      align-items: center;
      .svg-icon{
        width: 12px;
        height: 9px;
        display: block;
      }
    }
  }
  &__dynamic{
    font-size: 14px;
    font-weight: 600;
    &--up{
      color: #36b067;
    }
    &--down{
      color: #e67c27;
    }
  }
}
.cs-col1{
  width: 700px;
}
.cs-col2{
  width: 215px;
}
.cs-col3{
  width: 150px;
  margin-left: auto;
}
.channel-sales__table{
  min-width: 400px;
}
@media (max-width: 767px) {
  .channel-sales__table-wrap{
    margin-right: -20px;
    overflow: auto;
  }
}
</style>
